import UserActions from "./user"
import { purchaseCredits } from "./user"

const Actions = Object.assign({}, UserActions, purchaseCredits)

export * from "./event/index.js"
export * from "./room/index.js"
export * from "./speaker/index.js"
export * from "./presentation/index.js"
export * from "./site/index.js"
export * from "./contact/index.js"

export default Actions